'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    if (this.state.focused) {
        theme = Object.assign({}, theme, {
            selectedBackground: theme.focusSelectedBackground,
            pointerBackground: theme.focusPointerBackground
        });
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            font: theme.tsNormal + '/' + theme.tlNormal + ' "' + theme.fontFamily + '"',
            position: 'relative',
            display: theme.display,
            width: theme.width,
            minWidth: theme.minWidth
        },
        progress: {
            width: '100%',
            height: theme.gutter + 'px',
            position: 'relative',
            // + pointer icon offset
            padding: '10px 0',

            '&:after': {
                content: '""',
                display: 'block',
                width: '100%',
                height: theme.height,
                background: theme.background,
                position: 'absolute',
                top: '10px',
                left: 0,
                borderRadius: theme.borderRadius,
                zIndex: 1
            },

            '&:hover': {
                cursor: 'pointer'
            }
        },
        bar: {
            zIndex: 2,
            position: 'absolute',
            backgroundColor: theme.selectedBackground,
            top: '10px',
            left: 0,
            height: theme.height,
            borderRadius: theme.borderRadius,
            transitionProperty: 'background',
            transitionDuration: theme.transitionDuration,
            transitionTimingFunction: theme.transitionFunction
        },
        img: {
            width: '12px',
            height: '12px',
            background: theme.pointerBackground,
            position: 'absolute',
            borderRadius: theme.pointerBorderRadius,
            top: '-4px',
            right: '-6px',
            outline: '0 none',
            border: '0 none',
            padding: 0,
            margin: 0,
            cursor: 'move',
            zIndex: 4,
            transitionProperty: 'background',
            transitionDuration: theme.transitionDuration,
            transitionTimingFunction: theme.transitionFunction,

            '&:after': {
                content: '""',
                display: 'block',
                width: '12px',
                height: '12px',
                background: theme.pointerBackground,
                position: 'absolute',
                borderRadius: theme.pointerBorderRadius,
                top: 0,
                right: 0,
                transitionProperty: 'transform, background',
                transitionDuration: theme.transitionDuration,
                transitionTimingFunction: theme.transitionFunction,
                transform: 'scale(0)',
                transformOrigin: 'center',
                opacity: 0.38,
                zIndex: 3
            },

            '&:hover:after': {
                transform: 'scale(2)'
            }
        },
        input: {
            display: 'none'
        },
        hint: {
            zIndex: 3,
            position: 'absolute',
            backgroundColor: theme.elBlack,
            top: '-68px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: theme.gutter * 2 + 'px',
            color: theme.tInversion,
            fontSize: theme.tsSmall,
            lineHeight: theme.tlSmall,
            boxShadow: '0 8px 12px 0 ' + theme.elShadow + ', 0 6px 12px 0 ' + theme.elShadow,
            borderRadius: '4px'
        },
        hintTriangle: {
            display: 'block',
            position: 'absolute',
            width: 0,
            height: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            top: '100%',
            right: 'auto',
            bottom: 'auto',
            border: '0 none',
            // boxShadow: `0 8px 12px 0 ${theme.elShadow}, 0 6px 12px 0 ${theme.elShadow}`,
            zIndex: 2,
            borderWidth: '12px',
            borderBottomColor: 'transparent',
            borderLeftColor: 'transparent',
            borderRightColor: 'transparent',
            borderTopColor: theme.elBlack,
            borderStyle: 'solid'
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        progress: (0, _aphroditeJss.css)(styleList.progress),
        bar: (0, _aphroditeJss.css)(styleList.bar),
        img: (0, _aphroditeJss.css)(styleList.img),
        input: (0, _aphroditeJss.css)(styleList.input),
        hint: (0, _aphroditeJss.css)(styleList.hint),
        hintTriangle: (0, _aphroditeJss.css)(styleList.hintTriangle)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        display: 'inline-block',
        borderRadius: theme.gutter / 2 + 'px',
        width: 'auto',
        minWidth: theme.gutter * 20 + 'px',
        height: theme.gutter / 2 + 'px',
        background: theme.elDivider,

        selectedBackground: theme.elAccent,

        pointerBackground: theme.elAccent,
        pointerBorderRadius: '50%',

        focusPointerBackground: theme.elAccentDark,
        focusSelectedBackground: theme.elAccentDark
    };
};